<div class='modal-header'>
  <h4 class='modal-title'>
    {{startDate | date}} - {{endDate | date}}
  </h4>
  <a class='clickable' title='Schließen' aria-label='Close' (click)='modal.close(false)'>
    <span><i class='fas fa-times'></i></span>
  </a>
</div>

<div class='modal-body'>
  <div class='row'>
    <div class='col-6'>
      <ngb-datepicker #dp1 [(ngModel)]="start" (navigate)="date = $event.next" (ngModelChange)="updateStart()"></ngb-datepicker>
    </div>

    <div class='col-6'>
      <ngb-datepicker #dp2 [(ngModel)]="end" (navigate)="date = $event.next" (ngModelChange)="updateEnd()"></ngb-datepicker>
    </div>
  </div>
</div>

<div class='modal-footer'>
  <button class='btn btn-success' type='button' (click)="clickSearch()">
  {{ confirmText }}
  </button>

  <button class='btn btn-dark' (click)='modal.close(false)'>
    Abbrechen
  </button>
</div>